import { CONTACT } from "../lib/constants";

// Inline WhatsApp glyph (lucide doesn't ship one)
const WhatsAppGlyph = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20.52 3.48A11.94 11.94 0 0 0 12.05 0C5.5 0 .15 5.34.15 11.9c0 2.1.55 4.15 1.6 5.96L0 24l6.3-1.65a11.95 11.95 0 0 0 5.74 1.46h.01c6.55 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.17-3.43-8.43ZM12.05 21.6h-.01a9.7 9.7 0 0 1-4.94-1.35l-.36-.21-3.74.98 1-3.65-.23-.37a9.66 9.66 0 0 1-1.5-5.1c0-5.36 4.36-9.7 9.78-9.7 2.6 0 5.05 1.01 6.9 2.85a9.66 9.66 0 0 1 2.86 6.86c0 5.36-4.36 9.7-9.76 9.7Zm5.6-7.27c-.31-.16-1.82-.9-2.1-1-.28-.1-.49-.16-.7.16-.2.31-.8 1-.98 1.2-.18.21-.36.23-.67.08-.31-.16-1.3-.48-2.47-1.52a9.27 9.27 0 0 1-1.71-2.13c-.18-.31-.02-.48.13-.63.14-.14.31-.36.46-.54.16-.18.21-.31.31-.52.1-.21.05-.39-.03-.55-.08-.16-.7-1.69-.96-2.31-.25-.6-.51-.52-.7-.53l-.6-.01c-.21 0-.55.08-.84.39-.28.31-1.1 1.07-1.1 2.6 0 1.54 1.13 3.02 1.29 3.23.16.21 2.22 3.4 5.39 4.77.75.32 1.34.51 1.8.66.76.24 1.45.21 2 .13.61-.09 1.82-.74 2.08-1.46.26-.72.26-1.34.18-1.46-.07-.13-.28-.21-.59-.37Z" />
  </svg>
);

export default function WhatsAppButton() {
  if (!CONTACT.whatsappNumber) return null;
  const url = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    CONTACT.whatsappMessage
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Stuur foto via WhatsApp"
      className="fixed z-[55] bottom-5 right-5 md:bottom-8 md:right-8 group"
      data-testid="whatsapp-fab"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 blur-md group-hover:opacity-50 transition" />
      <span className="relative flex items-center gap-2 md:gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-3 pr-4 md:pl-4 md:pr-5 py-3 rounded-full shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition">
        <WhatsAppGlyph className="w-5 h-5 md:w-6 md:h-6" />
        <span className="hidden sm:inline text-xs md:text-sm font-medium font-body whitespace-nowrap">
          Stuur foto via WhatsApp
        </span>
      </span>
    </a>
  );
}
